import type { ModuleInjectionTable } from '@open-mercato/shared/modules/widgets/injection'

export const injectionTable: ModuleInjectionTable = {
  'crud-form:train_planning:train_plan:fields': [
    {
      widgetId: 'rolling_stock.injection.rolling-stock-train-plan-selector',
      priority: 10,
    },
  ],
}

export default injectionTable
